export const parseAnnouncement = (rawMessage: TRawAnnouncement, isFirstLoad: boolean = false): TParsedMessage => {
  const message = rawMessage.message

  // Expresión regular para buscar el emoji y capturar el grupo
  const emojiRegex = /^(\p{Emoji})/u
  const emojiMatch = message.match(emojiRegex)
  const emoji = emojiMatch ? emojiMatch[1] : ''

  // Expresión regular para buscar el título y capturar el grupo
  const titleRegex = /\p{Emoji}(.*?)\n\n/u
  const titleMatch = message.match(titleRegex)
  const title = titleMatch ? titleMatch[1] : ''

  // Expresión regular para buscar el párrafo y capturar el grupo
  const paragraphRegex = /\n\n(.*)/
  const paragraphMatch = message.match(paragraphRegex)
  const paragraph = paragraphMatch ? paragraphMatch[1] : ''

  // Objeto con las propiedades emoji, title y paragraph
  const result = {
    emoji: emoji,
    title: title,
    paragraph: paragraph,
  }
  return { isFirstLoad, ...rawMessage, message: result }
}
